


















import Enumerable from "linq";
import { Mixins, Component, Prop, Emit, Watch } from "vue-property-decorator";
import { HisInformationSetting } from "../../../../../../../base/domain/his";
import { ElTable } from "element-ui/types/table";

@Component
export default class HisInformationItemSelector extends Mixins() {
  data() {
    return {
      selectedItem: null as HisInformationSetting,
    };
  }
  selectedItem: HisInformationSetting;

  @Prop()
  tableData: HisInformationSetting[];

  $refs!: {
    table: ElTable,
  };

  click(row: HisInformationSetting) {
    if (!row) { return; }
    this.selectedItem = row;
  }

  changeSelection(row: HisInformationSetting) {
    this.$nextTick(() => {
      const target = Enumerable.from(this.tableData).firstOrDefault(s => !!row && s.key === row.key);
      if (!target) {
        this.$refs.table.clearSelection();
        return;
      }
      this.$refs.table.setCurrentRow(target);
      this.selectedItem = row;
      this.hisInformationItemSelected(this.selectedItem);
    });
  }

  @Watch("selectedItem")
  onSelectedItemUpdated(newValue: HisInformationSetting, oldValue: HisInformationSetting) {
    this.hisInformationItemSelected(this.selectedItem);
  }

  @Emit("hisInformationItemSelected")
  hisInformationItemSelected(value: HisInformationSetting): void {}
}
